/* eslint-disable */
import {createWebHashHistory, createRouter} from "vue-router";

import Login2 from "@/components/Login2.vue";
import Dashboard from "@/components/Dashboard.vue";






import otp from "@/components/otp.vue";
import otp2 from "@/components/otp2.vue";




import { authUrl, execute, getRight } from "@/api";


import AttendanceTimesheet from "@/components/leaveAndAttendance/AttendanceTimesheet.vue";
import EmployeeRegister from "@/components/employeeRegister/EmployeeRegister.vue";
import EmployeeDetailsView from "@/components/employeeRegister/EmployeeDetailsView.vue";
import EmployeeCreate from "@/components/employeeRegister/EmployeeCreate.vue";
import EmployeeEdit from "@/components/employeeRegister/EmployeeEdit.vue";
import OrgStructureManagement from "@/components/employeeRegister/OrgStructureManagement.vue";
import KpiTemplatesManagement from "@/components/employeeRegister/KpiTemplatesManagement.vue";
import EmployeeApprovalsNew from "@/components/employeeApproval/EmployeeApprovalsNew.vue";
import EmployeeApprovalsNewVerification from "@/components/employeeApproval/EmployeeApprovalsNewVerification.vue";
import EmployeeApprovalsEditApprovals from "@/components/employeeApproval/EmployeeApprovalsEditApprovals.vue";
import EmployeeApprovalsRejected from "@/components/employeeApproval/EmployeeApprovalsRejected.vue";
import EmployeeApprovalsApproved from "@/components/employeeApproval/EmployeeApprovalsApproved.vue";
import AttendanceLeave from "@/components/leaveAndAttendance/AttendanceLeave.vue";
import Projects from "@/components/projectConsultants/Projects.vue";
import ReportDaily from "@/components/reports/ReportDaily.vue";
import ReportMonthly from "@/components/reports/ReportMonthly.vue";
import AttendanceDetailedReport from "@/components/reports/AttendanceDetailedReport.vue";
import ReportHhrReport from "@/components/reports/ReportHhrReport.vue";
import ReportAwol from "@/components/reports/ReportAwol.vue";
import OffDutyDetails from "@/components/reports/OffDutyDetails.vue";
import HrTransfers from "@/components/hrActions/HrTransfers.vue";
import HrEvents from "@/components/hrActions/HrEvents.vue";
import HrEventsResponse from "@/components/hrActions/HrEventsResponse.vue";
import HrMeetings from "@/components/hrActions/HrMeetings.vue";
import HrWarnings from "@/components/hrActions/HrWarnings.vue";
import PipManagement from "@/components/hrActions/PipManagement.vue";
import AssetsAll from "@/components/assets/AssetsAll..vue";
import AssetsNew from "@/components/assets/AssetsNew..vue";
import ReconUploadPayroll from "@/components/payrollRecon/ReconUploadPayroll..vue";
import ReconHistory from "@/components/payrollRecon/ReconHistory.vue";
import ViewDiscrepancy from "@/components/payrollRecon/ViewDiscrepancy.vue";


import ImprestRequest from "@/components/imprest/ImprestRequest.vue";
import ImprestApproval from "@/components/imprest/ImprestApproval.vue";
import ImprestReconciliation from "@/components/imprest/ImprestReconciliation.vue";
import ImprestHistory from "@/components/imprest/ImprestHistory.vue";
import SeparationTermination from "@/components/separation/SeparationTermination.vue";
import SeparationFNF from "@/components/separation/SeparationFNF.vue";
import Attrition from "@/components/attrition/Attrition.vue";
import ModuleRedesignation from "@/components/modules/ModuleRedesignation.vue";
import ModuleRedeployment from "@/components/modules/ModuleRedeployment.vue";
import ModuleRedeploymentPlan from "@/components/modules/ModuleRedeploymentPlan.vue";
import ModuleEmployeesSkillsAudits from "@/components/modules/ModuleEmployeesSkillsAudits.vue";
import ModuleSkillsAuditInventory from "@/components/modules/ModuleSkillsAuditInventory.vue";
import ModuleSkillsAuditSkillGap from "@/components/modules/ModuleSkillsAuditSkillGap.vue";
import ModuleSkillsAuditMonitoringEvaluation from "@/components/modules/ModuleSkillsAuditMonitoringEvaluation.vue";
import ModuleConfirmationProbation from "@/components/modules/ModuleConfirmationProbation.vue";
import ModuleActingAppointment from "@/components/modules/ModuleActingAppointment.vue";
import ModuleBoardDecisions from "@/components/modules/ModuleBoardDecisions.vue";
import ModuleComplianceUnit from "@/components/modules/ModuleComplianceUnit.vue";
import ModuleHrKnowledge from "@/components/modules/ModuleHrKnowledge.vue";
import ModuleEducationHr from "@/components/modules/ModuleEducationHr.vue";
import CabinetManagementModule from "@/components/modules/CabinetManagementModule.vue";
import ModuleEmploymentTypes from "@/components/modules/ModuleEmploymentTypes.vue";
import ModuleShortTermEmployment from "@/components/modules/ModuleShortTermEmployment.vue";
import CountyAttorneyDocuments from "@/components/modules/CountyAttorneyDocuments.vue";
import DocumentsFromAttorney from "@/components/modules/DocumentsFromAttorney.vue";
import DocumentsGeneral from "@/components/documents/DocumentsGeneral..vue";
import ReportLeave from "@/components/reports/ReportLeave.vue";
import ReportTimeSheet from "@/components/reports/ReportTimeSheet.vue";
import SingleReport from "@/components/reports/SingleReport.vue";
import PayrollCsvReconciliation from "@/components/reports/PayrollCsvReconciliation.vue";
import SkillsAuditReport from "@/components/reports/SkillsAuditReport.vue";
import PensionGratuity from "@/components/directorHr/PensionGratuity.vue";
import LeavePlanning from "@/components/directorHr/LeavePlanning.vue";
import RetirementManagement from "@/components/directorHr/RetirementManagement.vue";
import LastExpense from "@/components/directorHr/LastExpense.vue";
import HrPsbRequests from "@/components/directorHr/HrPsbRequests.vue";
import WealthDeclaration from "@/components/directorHr/WealthDeclaration.vue";
import DisciplinaryHrActions from "@/components/directorHr/DisciplinaryHrActions.vue";
import Assets from "@/components/hrActions/Assets.vue";
import Promotions from "@/components/hrActions/Promotions.vue";
import HrAnnouncements from "@/components/hrActions/HrAnnouncements.vue";


//Holiday components
import Holidays from "@/components/hrActions/Holidays.vue";
import HolidayCategories from "@/components/hrActions/HolidayCategories.vue";
import HolidayStatistics from "@/components/hrActions/HolidayStatistics.vue";
import HolidayCalendar from "@/components/hrActions/HolidayCalendar.vue";

//Payroll components
import Payroll from "@/components/payroll/Payroll.vue";
import PayrollSetupManagement from "@/components/payroll/PayrollSetupManagement.vue";

//Appraisal



import DepartmentManagement from "@/components/employeeRegister/DepartmentManagement.vue";
import FileRegistry from "@/components/employeeRegister/FileRegistry.vue";
import EmployeeBulkUpload from "@/components/employeeRegister/EmployeeBulkUpload.vue";



//Employee Self Service
import EmployeeProfile from "@/components/employeeSelfService/EmployeeProfile.vue";
import EmployeeDashboard from "@/components/employeeSelfService/EmployeeDashboard.vue";
import EmployeeLeaveApply from "@/components/employeeSelfService/MyLeave/EmployeeLeaveApply.vue";
import EmployeeLeaveHistory from "@/components/employeeSelfService/MyLeave/EmployeeLeaveHistory.vue";
import EmployeeLeaveBalance from "@/components/employeeSelfService/MyLeave/EmployeeLeaveBalance.vue";
import EmployeeLeaveCalendar from "@/components/employeeSelfService/MyLeave/EmployeeLeaveCalendar.vue";
import EmployeeAttendanceRecords from "@/components/employeeSelfService/MyAttendance/EmployeeAttendanceRecords.vue";
import EmployeeAttendanceClock from "@/components/employeeSelfService/MyAttendance/EmployeeAttendanceClock.vue";
import EmployeeAttendanceSummary from "@/components/employeeSelfService/MyAttendance/EmployeeAttendanceSummary.vue";
import RemoteAttendanceApprovals from "@/components/leaveAndAttendance/RemoteAttendanceApprovals.vue";
import EmployeePayrollPayslips from "@/components/employeeSelfService/MyPayroll/EmployeePayrollPayslips.vue";
import EmployeePayrollTax from "@/components/employeeSelfService/MyPayroll/EmployeePayrollTax.vue";
import EmployeePayrollHistory from "@/components/employeeSelfService/MyPayroll/EmployeePayrollHistory.vue";
import EmployeeDocumentsView from "@/components/employeeSelfService/MyDocuments/EmployeeDocumentsView.vue";
import EmployeeDocumentsUpload from "@/components/employeeSelfService/MyDocuments/EmployeeDocumentsUpload.vue";
import EmployeeCoiaDeclaration from "@/components/employeeSelfService/EmployeeCoiaDeclaration.vue";
import EmployeeSkillsAuditSubmit from "@/components/employeeSelfService/EmployeeSkillsAuditSubmit.vue";
import EmployeeSkillsAuditAssessment from "@/components/employeeSelfService/EmployeeSkillsAuditAssessment.vue";
import EmployeePerformanceAppraisals from "@/components/employeeSelfService/MyPerformance/EmployeePerformanceAppraisals.vue";
import EmployeePerformanceSelf from "@/components/employeeSelfService/MyPerformance/EmployeePerformanceSelf.vue";
import EmployeeAppraisalDetails from "@/components/employeeSelfService/MyPerformance/EmployeeAppraisalDetails.vue";
import ManagerDashboard from "@/components/employeePerfomance/ManagerDashboard.vue";
import HRDashboard from "@/components/employeePerfomance/HRDashboard.vue";
import ManagerAppraisalView from "@/components/employeePerfomance/ManagerAppraisalView.vue";
import ManagerReviewForm from "@/components/employeePerfomance/ManagerReviewForm.vue";
import HRAppraisalView from "@/components/employeePerfomance/HRAppraisalView.vue";
import HRReviewForm from "@/components/employeePerfomance/HRReviewForm.vue";
import ReportsAndAnalytics from "@/components/employeePerfomance/ReportsAndAnalytics.vue";
import AppraisalCyclesManagement from "@/components/employeePerfomance/AppraisalCyclesManagement.vue";
import EmployeeAnnouncements from "@/components/employeeSelfService/EmployeeAnnouncements.vue";
import MyMeetings from "@/components/employeeSelfService/MyMeetings.vue";
import MyWarnings from "@/components/employeeSelfService/MyWarnings.vue";
import PositionManagement from "@/components/employeeRegister/PositionManagement.vue";
import CategoryRoleManagement from "@/components/employeeRegister/CategoryRoleManagement.vue";
import UserManagement from "@/components/systemManagement/UserManagement.vue";
import AuditLogs from "@/components/systemManagement/AuditLogs.vue";
import ChangePassword from "@/components/employeeRegister/ChangePassword.vue";
import Forgotpassword from "@/components/employeeRegister/Forgotpassword.vue";
import LeaveBalancesManagement from "@/components/leaveAndAttendance/LeaveBalancesManagement.vue";
import LeaveTypesManagement from "@/components/leaveAndAttendance/LeaveTypesManagement.vue";
import ShiftManagement from "@/components/leaveAndAttendance/ShiftManagement.vue";
import PollsManagement from "@/components/polls/PollsManagement.vue";
import MyPolls from "@/components/polls/MyPolls.vue";
import PollVote from "@/components/polls/PollVote.vue";

// Recruitment components
import VacancyManagement from "@/components/recruitment/VacancyManagement.vue";
import Applicants from "@/components/recruitment/Applicants.vue";
import ShortlistingManagement from "@/components/recruitment/ShortlistingManagement.vue";
import InterviewManagement from "@/components/recruitment/InterviewManagement.vue";
import AppointmentManagement from "@/components/recruitment/AppointmentManagement.vue";

// Certifications (Training & Development)
import TrainingsCatalog from "@/components/Certifications/TrainingsCatalog.vue";
import EmployeeCertifications from "@/components/Certifications/EmployeeCertifications.vue";
import EmployeeSkills from "@/components/Certifications/EmployeeSkills.vue";
import TrainingManagement from "@/components/Certifications/TrainingManagement.vue";
import TrainingCalendar from "@/components/Certifications/TrainingCalendar.vue";
import TrainingEvaluations from "@/components/Certifications/TrainingEvaluations.vue";
import MyTraining from "@/components/employeeSelfService/MyTraining.vue";
import MyRedeployment from "@/components/employeeSelfService/MyRedeployment.vue";


const routes =[
    //Salary
    {
        path: "/payroll",
        name: "payroll",
        component: Payroll,
        meta: {public: false}
    },

    //Salary
    {
        path: "/payroll-setup",
        name: "payroll-setup",
        component: PayrollSetupManagement,
        meta: {public: false}
    },


    // Holiday routes
    {
        path: "/holidays",
        name: "holidays",
        component: Holidays,
        meta: {public: false}
    },
    {
        path: '/holiday-categories',
        name: 'holiday-categories',
        component: HolidayCategories,
        meta: { public: true }
    },
    {
        path: '/holiday-statistics',
        name: 'holiday-statistics',
        component: HolidayStatistics,
        meta: { public: true }
    },
    {
        path: '/holiday-calendar',
        name: 'holiday-calendar',
        component: HolidayCalendar,
        meta: { public: true }
    },


    {
        path: "/announcements",
        name: "announcements",
        component: HrAnnouncements,
        meta: {public: false}
    },
    {
        path: "/polls-management",
        name: "polls-management",
        component: PollsManagement,
        meta: {public: false}
    },
    {
        path: "/my-polls",
        name: "my-polls",
        component: MyPolls,
        meta: {public: false}
    },
    {
        path: "/poll-vote/:id",
        name: "poll-vote",
        component: PollVote,
        meta: {public: false}
    },
    {
        path: "/hr-promotions",
        name: "hr-promotions",
        component: Promotions,
        meta: {public: false}
    },
    {
        path: "/assets",
        name: "assets",
        component: Assets,
        meta: {public: false}
    },
    {
        path: "/report-timesheet",
        name: "report-timesheet",
        component: AttendanceTimesheet,
        meta: {public: false}
    },
    {
        path: "/report-leave",
        name: "report-leave",
        component: ReportLeave,
        meta: {public: false}
    },

    {
        path: "/documents-general",
        name: "documents-general",
        component: DocumentsGeneral,
        meta: {public: false}
    },



    {
        path:"/imprest-history",
        name:"imprest-history",
        component: ImprestHistory,
        meta:{public: false,}
    },
    {
        path:"/imprest-reconciliation",
        name:"imprest-reconciliation",
        component: ImprestReconciliation,
        meta:{public: false,}
    },
    {
        path:"/imprest-approval",
        name:"imprest-approval",
        component: ImprestApproval,
        meta:{public: false,}
    },

    {
        path:"/imprest-request",
        name:"imprest-request",
        component: ImprestRequest,
        meta:{public: false,}
    },



   {
        path:"/view_discrepancy",
        name:"view_discrepancy",
        component: ViewDiscrepancy,
        meta:{public: false,}
    },

    {
        path:"/recon-history",
        name:"recon-history",
        component: ReconHistory,
        meta:{public: false,}
    },
    {
        path:"/recon-upload-payroll",
        name:"recon-upload-payroll",
        component: ReconUploadPayroll,
        meta:{public: false,}
    },
    {
        path:"/assets-new",
        name:"assets-new",
        component: AssetsNew,
        meta:{public: false,}
    },
    {
        path:"/assets-all",
        name:"assets-all",
        component: AssetsAll,
        meta:{public: false,}
    },
    {
        path:"/hr-warnings",
        name:"hr-warnings",
        component: HrWarnings,
        meta:{public: false,}
    },
    {
        path: "/pip-management",
        name: "pip-management",
        component: PipManagement,
        meta: {public: false}
    },

    {
        path:"/hr-meetings",
        name:"hr-meetings",
        component: HrMeetings,
        meta:{public: false,}
    },
    {
        path:"/hr-events",
        name:"hr-events",
        component: HrEvents,
        meta:{public: false,}
    },
    {
        path:"/hr-my-events",
        name:"hr-my-events",
        component: HrEventsResponse,
        meta:{public: true}
    },


    {
        path:"/hr-transfers",
        name:"hr-transfers",
        component: HrTransfers,
        meta:{public: false,}
    },

    {
        path:"/off-duty-details",
        name:"off-duty-details",
        component: OffDutyDetails,
        meta:{public: false,}
    },
    {
        path:"/report-awol",
        name:"report-awol",
        component: ReportAwol,
        meta:{public: false,}
    },

    {
        path:"/report-hr-report",
        name:"report-hr-report",
        component: ReportHhrReport,
        meta:{public: false,}
    },
    {
        path:"/report-monthly",
        name:"report-monthly",
        component: ReportMonthly,
        meta:{public: false,}
    },

    {
        path:"/report-daily",
        name:"report-daily",
        component: ReportDaily,
        meta:{public: false,}
    },
        {
        path: "/report-monthly-detailed",
        name: "report-monthly-detailed",
        component: AttendanceDetailedReport,
        meta: {public: false}
    },
    {
        path: "/reports-hub",
        redirect: { name: "report-staff-establishment" }
    },
    {
        path: "/report-staff-establishment",
        name: "report-staff-establishment",
        component: SingleReport,
        meta: { public: false, reportType: "department_staff_establishment" }
    },
    {
        path: "/report-attrition",
        name: "report-attrition",
        component: SingleReport,
        meta: { public: false, reportType: "attrition" }
    },
    {
        path: "/report-wealth-compliance",
        name: "report-wealth-compliance",
        component: SingleReport,
        meta: { public: false, reportType: "wealth_declaration_compliance" }
    },
    {
        path: "/report-wealth-non-compliant",
        name: "report-wealth-non-compliant",
        component: SingleReport,
        meta: { public: false, reportType: "wealth_declaration_non_compliant" }
    },
    {
        path: "/report-department-wage-bill",
        name: "report-department-wage-bill",
        component: SingleReport,
        meta: { public: false, reportType: "department_wage_bill" }
    },
    {
        path: "/report-county-wage-bill",
        name: "report-county-wage-bill",
        component: SingleReport,
        meta: { public: false, reportType: "county_wage_bill" }
    },
    {
        path: "/payroll-csv-reconciliation",
        name: "payroll-csv-reconciliation",
        component: PayrollCsvReconciliation,
        meta: { public: false }
    },
    {
        path: "/skills-audit-report",
        name: "skills-audit-report",
        component: SkillsAuditReport,
        meta: { public: false }
    },
    {
        path: "/pension-gratuity",
        name: "pension-gratuity",
        component: PensionGratuity,
        meta: {public: false}
    },
    {
        path: "/leave-planning",
        name: "leave-planning",
        component: LeavePlanning,
        meta: {public: false}
    },
    {
        path: "/retirement-management",
        name: "retirement-management",
        component: RetirementManagement,
        meta: {public: false}
    },
    {
        path: "/last-expense",
        name: "last-expense",
        component: LastExpense,
        meta: {public: false}
    },
    {
        path: "/hr-psb-requests",
        name: "hr-psb-requests",
        component: HrPsbRequests,
        meta: {public: false}
    },
    {
        path: "/wealth-declaration",
        name: "wealth-declaration",
        component: WealthDeclaration,
        props: { viewMode: "approvals" },
        meta: {public: false}
    },
    {
        path: "/wealth-declaration-approvals",
        name: "wealth-declaration-approvals",
        component: WealthDeclaration,
        props: { viewMode: "approvals" },
        meta: {public: false}
    },
    {
        path: "/wealth-declaration-approved",
        name: "wealth-declaration-approved",
        component: WealthDeclaration,
        props: { viewMode: "approved" },
        meta: {public: false}
    },
    {
        path: "/disciplinary-hr-actions",
        name: "disciplinary-hr-actions",
        component: DisciplinaryHrActions,
        meta: {public: false}
    },


    {
        path:"/separation-termination",
        name:"separation-termination",
        component: SeparationTermination,
        meta:{public: false,}
    },
    {
        path:"/separation-fnf",
        name:"separation-fnf",
        component: SeparationFNF,
        meta:{public: false,}
    },


    {
        path:"/projects",
        name:"projects",
        component: Projects,
        meta:{public: false}
    },
    {
        path:"/employee-details-view",
        name:"employee-details-view",
        component: EmployeeDetailsView,
        meta:{public: false}
    },

    {
        path:"/attendance-leave",
        name:"attendance-leave",
        component: AttendanceLeave,
        meta:{public: false}
    },
    {
        path:"/attendance-leave-manage",
        name:"attendance-leave-manage",
        component: LeaveBalancesManagement,
        meta:{public: false}
    },

    {
        path:"/attendance-timesheet",
        name:"attendance-timesheet",
        component: AttendanceTimesheet,
        meta:{public: false,}
    },
    {
        path:"/shift-management",
        name:"shift-management",
        component: ShiftManagement,
        meta:{public: false}
    },

    {
        path: "/employee-approvals-rejected",
        name: "employee-approvals-rejected",
        component: EmployeeApprovalsRejected,
        meta: {public: false}
    },

    {
        path: "/employee-approvals-approved",
        name: "employee-approvals-approved",
        component: EmployeeApprovalsApproved,
        meta: {public: false}
    },

    {
        path:"/employee-approvals-edit-approvals",
        name:"employee-approvals-edit-approvals",
        component: EmployeeApprovalsEditApprovals,
        meta:{public: false}
    },

    {
        path: "/employee-approvals-new-verification",
        name: "employee-approvals-new-verification",
        component: EmployeeApprovalsNewVerification,
        meta: {public: false}
    },

    {
        path: "/employee-approvals-new",
        name: "employee-approvals-new",
        component: EmployeeApprovalsNew,
        meta: {public: false}
    },

    {
        path: "/employee-edit",
        name: "employee-edit",
        component: EmployeeEdit,
        meta: {public: false}
    },

    {
        path: "/employee-create",
        name: "employee-create",
        component: EmployeeCreate,
        meta: {public: false}
    },
    {
        path: "/employee-register",
        name: "employee-register",
        component: EmployeeRegister,
        meta: {public: false}
    },
    {
        path: "/org-structure",
        name: "org-structure",
        component: OrgStructureManagement,
        meta: {public: false}
    },
    {
        path: "/kpi-templates",
        name: "kpi-templates",
        component: KpiTemplatesManagement,
        meta: {public: false}
    },

    {
        path: "/employee-bulk-upload",
        name: "employee-bulk-upload",
        component: EmployeeBulkUpload,
        meta: {public: false}
    },

    {
        path: "/department-management",
        name: "department-management",
        component: DepartmentManagement,
        meta: {public: false}
    },
    {
        path: "/file-registry",
        name: "file-registry",
        component: FileRegistry,
        meta: {public: false}
    },
    {
        path: "/attrition",
        name: "attrition",
        component: Attrition,
        meta: {public: false}
    },
    {
        path: "/module-redesignation",
        name: "module-redesignation",
        component: ModuleRedesignation,
        meta: { public: false }
    },
    {
        path: "/module-redeployment",
        name: "module-redeployment",
        component: ModuleRedeployment,
        meta: { public: false, permission: ["REDEPLOYMENT_VIEW", "REDEPLOYMENT_MANAGE"] }
    },
    {
        path: "/module-redeployment-plan",
        name: "module-redeployment-plan",
        component: ModuleRedeploymentPlan,
        meta: { public: false, permission: ["REDEPLOYMENT_PLAN_CREATE", "REDEPLOYMENT_MANAGE", "REDEPLOYMENT_VIEW"] }
    },
    {
        path: "/module-employees-skills-audits",
        name: "module-employees-skills-audits",
        component: ModuleEmployeesSkillsAudits,
        meta: { public: false, permission: "EMPLOYEES SKILLS AUDITS" }
    },
    {
        path: "/module-skills-audit-inventory",
        name: "module-skills-audit-inventory",
        component: ModuleSkillsAuditInventory,
        meta: { public: false, permission: "SKILLS AUDIT SKILLS INVENTORY" }
    },
    {
        path: "/module-skills-audit-skill-gap",
        name: "module-skills-audit-skill-gap",
        component: ModuleSkillsAuditSkillGap,
        meta: { public: false, permission: "SKILLS AUDIT SKILL GAP" }
    },
    {
        path: "/module-skills-audit-me",
        name: "module-skills-audit-me",
        component: ModuleSkillsAuditMonitoringEvaluation,
        meta: { public: false, permission: "SKILLS AUDIT MONITORING EVALUATION" }
    },
    {
        path: "/module-confirmation-probation",
        name: "module-confirmation-probation",
        component: ModuleConfirmationProbation,
        meta: { public: false }
    },
    {
        path: "/module-acting-appointment",
        name: "module-acting-appointment",
        component: ModuleActingAppointment,
        meta: { public: false }
    },
    {
        path: "/module-board-decisions",
        name: "module-board-decisions",
        component: ModuleBoardDecisions,
        meta: { public: false }
    },
    {
        path: "/module-compliance-unit",
        name: "module-compliance-unit",
        component: ModuleComplianceUnit,
        meta: { public: false }
    },
    {
        path: "/module-hr-knowledge",
        name: "module-hr-knowledge",
        component: ModuleHrKnowledge,
        meta: { public: false }
    },
    {
        path: "/module-education-hr",
        name: "module-education-hr",
        component: ModuleEducationHr,
        meta: { public: false }
    },
    {
        path: "/module-cabinet",
        name: "module-cabinet",
        component: CabinetManagementModule,
        meta: { public: false }
    },
    {
        path: "/module-employment-types",
        name: "module-employment-types",
        component: ModuleEmploymentTypes,
        meta: { public: false }
    },
    {
        path: "/module-short-term-employment",
        name: "module-short-term-employment",
        component: ModuleShortTermEmployment,
        meta: { public: false }
    },
    {
        path: "/county-attorney-documents",
        name: "county-attorney-documents",
        component: CountyAttorneyDocuments,
        meta: { public: false }
    },
    {
        path: "/documents-from-attorney",
        name: "documents-from-attorney",
        component: DocumentsFromAttorney,
        meta: { public: false }
    },

    {
        path:"/otp",
        name:"otp",
        component: otp,
        meta:{public: false,}
    },
    {
        path:"/otp-verification",
        name:"otp2",
        component: otp2,
        meta:{public: false,}
    },


    {
        path: "/",
        name: "login",
        component: Login2,
        meta: { public: true }
    },
    {
        path: "/login",
        redirect: "/"
    },

    {
        path:"/dashboard",
        name:"dashboard",
        component: Dashboard,
        meta:{public: false}
    },

    //Employee Self service
    {
        path:"/employee-profile",
        name:"employee-profile",
        component: EmployeeProfile,
        meta:{public: false}
    },

    {
        path:"/employee-dashboard",
        name:"employee-dashboard",
        component: EmployeeDashboard,
        meta:{public: false}
    },

    {
        path:"/employee-leave-apply",
        name:"employee-leave-apply",
        component: EmployeeLeaveApply,
        meta:{public: false}
    },
    {
        path:"/leave-types",
        name:"leave-types",
        component: LeaveTypesManagement,
        meta:{public: false}
    },

    {
        path:"/employee-leave-history",
        name:"employee-leave-history",
        component: EmployeeLeaveHistory,
        meta:{public: false}
    },

   {
        path:"/employee-leave-balance",
        name:"employee-leave-balance",
        component: EmployeeLeaveBalance,
        meta:{public: false}
    },

    {
        path:"/employee-leave-calendar",
        name:"employee-leave-calendar",
        component: EmployeeLeaveCalendar,
        meta:{public: false}
    },

    {
        path:"/employee-attendance-records",
        name:"employee-attendance-records",
        component: EmployeeAttendanceRecords,
        meta:{public: false}
    },

    {
        path:"/employee-attendance-clock",
        name:"employee-attendance-clock",
        component: EmployeeAttendanceClock,
        meta:{public: false}
    },

    {
        path:"/employee-attendance-summary",
        name:"employee-attendance-summary",
        component: EmployeeAttendanceSummary,
        meta:{public: false}
    },
    {
        path:"/remote-attendance-approvals",
        name:"remote-attendance-approvals",
        component: RemoteAttendanceApprovals,
        meta:{public: false}
    },

{
        path:"/employee-payroll-payslips",
        name:"employee-payroll-payslips",
        component: EmployeePayrollPayslips,
        meta:{public: false}
    },

     {
        path:"/employee-payroll-tax",
        name:"employee-payroll-tax",
        component: EmployeePayrollTax,
        meta:{public: false}
    },

   {
        path:"/employee-payroll-history",
        name:"employee-payroll-history",
        component: EmployeePayrollHistory,
        meta:{public: false}
    },

 {
        path:"/employee-documents-view",
        name:"employee-documents-view",
        component: EmployeeDocumentsView,
        meta:{public: false}
    },
    {
        path:"/employee-documents-upload",
        name:"employee-documents-upload",
        component: EmployeeDocumentsUpload,
        meta:{public: false}
    },
    {
        path: "/employee-coia-declaration",
        name: "employee-coia-declaration",
        component: EmployeeCoiaDeclaration,
        meta: { public: false }
    },
    {
        path: "/my-skills-audit",
        name: "my-skills-audit",
        component: EmployeeSkillsAuditSubmit,
        meta: { public: false }
    },
    {
        path: "/skills-audit-assessment",
        name: "skills-audit-assessment",
        component: EmployeeSkillsAuditAssessment,
        meta: { public: false }
    },
    {
        path:"/my-appraisals",
        name:"my-appraisals",
        component: EmployeePerformanceAppraisals,
        meta:{public: false}
    },
    {
        path:"/employee-self-assessment",
        name:"employee-self-assessment",
        component: EmployeePerformanceSelf,
        meta:{public: false}
    },

    {
        path:"/appraisal-details",
        name:"appraisal-details",
        component: EmployeeAppraisalDetails,
        meta:{public: false}
    },
    {
        path:"/manager-dashboard",
        name:"manager-dashboard",
        component: ManagerDashboard,
        meta:{public: false}
    },

    {
        path:"/hr-dashboard",
        name:"hr-dashboard",
        component: HRDashboard,
        meta:{public: false}
    },

    {
        path:"/manager-appraisal-view",
        name:"manager-appraisal-view",
        component: ManagerAppraisalView,
        meta:{public: false}
    },

    {
        path:"/manager-review-form",
        name:"manager-review-form",
        component: ManagerReviewForm,
        meta:{public: false}
    },

    {
        path:"/hr-appraisal-view",
        name:"hr-appraisal-view",
        component: HRAppraisalView,
        meta:{public: false}
    },

   {
        path:"/hr-review-form",
        name:"hr-review-form",
        component: HRReviewForm,
        meta:{public: false}
    },

    {
        path:"/performance-reports",
        name:"performance-reports",
        component: ReportsAndAnalytics,
        meta:{public: false}
    },
    {
        path: "/appraisal-cycles",
        name: "appraisal-cycles",
        component: AppraisalCyclesManagement,
        meta: {public: false}
    },

     {
        path:"/employee-announcements",
        name:"employee-announcements",
        component: EmployeeAnnouncements,
        meta:{public: false}
    },

    {
        path:"/employee-my-meetings",
        name:"employee-my-meetings",
        component: MyMeetings,
        meta:{public: false}
    },
    {
        path:"/employee-my-warnings",
        name:"employee-my-warnings",
        component: MyWarnings,
        meta:{public: false}
    },

    {
        path:"/position-management",
        name:"position-management",
        component: PositionManagement,
        meta:{public: false}
    },
    {
        path: "/category-role-management",
        name: "category-role-management",
        component: CategoryRoleManagement,
        meta: { public: false }
    },
    {
        path: "/user-management",
        name: "user-management",
        component: UserManagement,
        meta: { public: false }
    },
    {
        path: "/audit-logs",
        name: "audit-logs",
        component: AuditLogs,
        meta: { public: false }
    },


 {
        path:"/change-password",
        name:"change-password",
        component: ChangePassword,
        meta:{public: true}
    },

    {
        path:"/forgot-password",
        name:"forgot-password",
        component: Forgotpassword,
        meta:{public: true}
    },
    {
        path:"/vacancy-management",
        name:"vacancy-management",
        component: VacancyManagement,
        meta:{public: false}
    },
    {
        path:"/applicants",
        name:"applicants",
        component: Applicants,
        meta:{public: false}
    },
    {
        path:"/shortlisting-management",
        name:"shortlisting-management",
        component: ShortlistingManagement,
        meta:{public: false}
    },
    {
        path:"/interview-management",
        name:"interview-management",
        component: InterviewManagement,
        meta:{public: false}
    },
    {
        path:"/appointment-management",
        name:"appointment-management",
        component: AppointmentManagement,
        meta:{public: false}
    },

    // Certifications (Training & Development) - roles 98-101
    {
        path: "/trainings-catalog",
        name: "trainings-catalog",
        component: TrainingsCatalog,
        meta: { public: false }
    },
    {
        path: "/employee-certifications",
        name: "employee-certifications",
        component: EmployeeCertifications,
        meta: { public: false }
    },
    {
        path: "/employee-skills",
        name: "employee-skills",
        component: EmployeeSkills,
        meta: { public: false }
    },
    {
        path: "/training-management",
        name: "training-management",
        component: TrainingManagement,
        meta: { public: false }
    },
    {
        path: "/training-calendar",
        name: "training-calendar",
        component: TrainingCalendar,
        meta: { public: false }
    },
    {
        path: "/training-evaluations",
        name: "training-evaluations",
        component: TrainingEvaluations,
        meta: { public: false }
    },
    {
        path: "/my-training",
        name: "my-training",
        component: MyTraining,
        meta: { public: false }
    },
    {
        path: "/my-redeployment",
        name: "my-redeployment",
        component: MyRedeployment,
        meta: { public: false, permission: ["REDEPLOYMENT_EMPLOYEE_ACK", "REDEPLOYMENT_EMPLOYEE_FEEDBACK"] }
    },


]
const router = createRouter({
    history: createWebHashHistory(),
    routes
});


let userActivityTimer;

const normalizeRouteKey = (route) => String(route || "")
    .trim()
    .replace(/^#/, "")
    .replace(/^\//, "")
    .toLowerCase();

const getSessionRbacMenus = () => {
    try {
        const raw = sessionStorage.getItem("rbac_menus");
        if (!raw) return [];
        const menus = JSON.parse(raw);
        return Array.isArray(menus) ? menus : [];
    } catch (_) {
        return [];
    }
};

const getRequiredPermissionsForRoute = (to) => {
    const required = [];

    // Support explicit route meta permission(s) when present.
    if (to?.meta?.permission) {
        if (Array.isArray(to.meta.permission)) required.push(...to.meta.permission);
        else required.push(to.meta.permission);
    }

    const routeCandidates = [
        normalizeRouteKey(to?.path),
        normalizeRouteKey(to?.name),
        normalizeRouteKey(to?.meta?.menuRoute)
    ].filter(Boolean);

    if (!routeCandidates.length) return required;

    const menus = getSessionRbacMenus();
    menus.forEach((menu) => {
        const menuRoute = normalizeRouteKey(menu?.route);
        if (!menuRoute || !routeCandidates.includes(menuRoute)) return;
        const isActive = !(menu?.is_active === false || menu?.is_active === 0 || String(menu?.is_active).trim() === "0");
        if (!isActive) return;
        const code = String(menu?.permission_code || "").trim();
        if (code) required.push(code);
    });

    return [...new Set(required.map((p) => String(p || "").trim()).filter(Boolean))];
};

const redirectUnauthorized = (to, next) => {
    if (to?.path === "/dashboard") {
        next("/employee-dashboard");
        return;
    }
    next("/dashboard");
};

router.beforeEach((to, from, next) => {
    // Reset the user activity timer on each navigation
    clearTimeout(userActivityTimer);

    // Role gate: System Management – Organization Structure
    if (to.name === "org-structure" && !getRight("ORG STRUCTURE")) {
        next("/dashboard");
        return;
    }
    // Role gate: Access profiles & roles
    if (to.name === "category-role-management" && !getRight("CATEGORY & ROLES")) {
        next("/dashboard");
        return;
    }
    if (to.name === "user-management" && !getRight("USER MANAGEMENT")) {
        next("/dashboard");
        return;
    }
    if (to.name === "audit-logs" && !getRight("AUDIT LOGS")) {
        next("/dashboard");
        return;
    }
    if (to.name === "county-attorney-documents" && !getRight("COUNTY ATTORNEY")) {
        next("/dashboard");
        return;
    }
    if (to.name === "documents-from-attorney" && !getRight(["DOCUMENTS FROM ATTORNEY", "COUNTY ATTORNEY"])) {
        next("/dashboard");
        return;
    }
    if (to.name === "module-short-term-employment" && !getRight("SHORT TERM EMPLOYMENT")) {
        next("/dashboard");
        return;
    }
    if (to.name === "module-redeployment" && !getRight(["REDEPLOYMENT_VIEW", "REDEPLOYMENT_MANAGE"])) {
        next("/dashboard");
        return;
    }
    if (to.name === "module-redeployment-plan" && !getRight(["REDEPLOYMENT_PLAN_CREATE", "REDEPLOYMENT_MANAGE", "REDEPLOYMENT_VIEW"])) {
        next("/dashboard");
        return;
    }
    if (to.name === "my-redeployment" && !getRight(["REDEPLOYMENT_EMPLOYEE_ACK", "REDEPLOYMENT_EMPLOYEE_FEEDBACK"])) {
        next("/dashboard");
        return;
    }
    // Certifications / Training module role gates (roles 98-101)
    if (to.name === "trainings-catalog" && !getRight("TRAININGS CATALOG")) {
        next("/dashboard");
        return;
    }
    if (to.name === "employee-certifications" && !getRight("EMPLOYEE CERTIFICATIONS")) {
        next("/dashboard");
        return;
    }
    if (to.name === "employee-skills" && !getRight("EMPLOYEE SKILLS")) {
        next("/dashboard");
        return;
    }
    if (to.name === "training-management" && !getRight("TRAINING MANAGEMENT")) {
        next("/dashboard");
        return;
    }
    if (to.name === "training-calendar" && !getRight("TRAINING CALENDAR")) {
        next("/dashboard");
        return;
    }
    if (to.name === "training-evaluations" && !getRight("TRAINING EVALUATIONS")) {
        next("/dashboard");
        return;
    }
    if (to.name === "my-training" && !getRight("MY TRAINING")) {
        next("/dashboard");
        return;
    }
    if (
        to.name === "payroll-csv-reconciliation" &&
        !getRight("REPORT_DEPARTMENT_WAGE_BILL") &&
        !getRight("PAYROLL REPORT") &&
        !getRight("UPLOAD PAYROLL") &&
        !getRight("REPORT_COUNTY_WAGE_BILL")
    ) {
        next("/dashboard");
        return;
    }
    if (to.name === "skills-audit-report" && !getRight("SKILLS AUDIT REPORT")) {
        next("/dashboard");
        return;
    }
    if (to.name === "skills-audit-assessment" && !getRight("MY SKILLS AUDIT ASSESSMENT")) {
        next("/dashboard");
        return;
    }
    if (to.name === "module-employees-skills-audits" && !getRight("EMPLOYEES SKILLS AUDITS")) {
        next("/dashboard");
        return;
    }
    if (to.name === "module-skills-audit-inventory" && !getRight("SKILLS AUDIT SKILLS INVENTORY")) {
        next("/dashboard");
        return;
    }
    if (to.name === "module-skills-audit-skill-gap" && !getRight("SKILLS AUDIT SKILL GAP")) {
        next("/dashboard");
        return;
    }
    if (to.name === "module-skills-audit-me" && !getRight("SKILLS AUDIT MONITORING EVALUATION")) {
        next("/dashboard");
        return;
    }
    if (to.name === "my-skills-audit" && !getRight("MY SKILLS AUDIT")) {
        next("/dashboard");
        return;
    }

    // Check if the target route requires authentication
    if (!to.meta.public && !to.hash.includes('/trade/')) {
        // Check if the user is logged in or not
        if (sessionStorage.getItem("isLoggedIn")) {
            const requiredPermissions = getRequiredPermissionsForRoute(to);
            if (requiredPermissions.length > 0 && !getRight(requiredPermissions)) {
                redirectUnauthorized(to, next);
                return;
            }

            // If yes, allow the navigation
            next();

            // Set up the user activity timer
            userActivityTimer = setTimeout(() => {
                // Log out the user after 5 minutes of inactivity
                sessionStorage.removeItem("isLoggedIn");
                next("/login");
            }, 5 * 60 * 1000); // 5 minutes in milliseconds
        } else {
            // If no, redirect the user to the login page
            next("/login");
        }
    } else {
        // If the target route does not require authentication or has parameters, allow the navigation
        next();
    }
});

// Optionally, you may want to handle user activity within the application
// to reset the timer. Here's an example assuming you have a user activity event.

// Example: Reset timer on user activity
function handleUserActivity() {
    clearTimeout(userActivityTimer);
    userActivityTimer = setTimeout(() => {
        // Log out the user after 5 minutes of inactivity

        const data = new FormData();
        data.append("function", "timeout");
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
        execute(data, authUrl)
            .then(() => {

                sessionStorage.removeItem("isLoggedIn");
                router.push("/login");

            })
            .catch(() => {
                // alert(e.message);
            });



    }, 20 * 60 * 1000); // 5 minutes in milliseconds
}

// Attach an event listener for user activity (e.g., mousemove, keypress, etc.)
document.addEventListener("mousemove", handleUserActivity);
document.addEventListener("keypress", handleUserActivity);

// Remember to remove event listeners when they are no longer needed (e.g., when user logs out)
// document.removeEventListener("mousemove", handleUserActivity);
// document.removeEventListener("keypress", handleUserActivity);

export default router;



